import { z } from 'zod';

import {
  type AssignRoleToMembershipRequest,
  type CreateRoleRequest,
  type CreateRoleResponse,
  type GetRoleResponse,
  type ListRolesResponse,
  type MembershipRoleDto,
  type RoleDetailDto,
  type RoleDto,
  type SetMembershipRolesRequest,
  type SetMembershipRolesResponse,
  type UpdateRoleRequest,
  type UpdateRoleResponse,
} from './roles.dto.js';

const timestampSchema = z.iso.datetime();

export const RoleSchema: z.ZodType<RoleDto> = z.object({
  id: z.uuid(),
  companyId: z.uuid(),
  name: z.string().trim().min(1),
  isSystemRole: z.boolean(),
  createdAt: timestampSchema,
});

export const ListRolesResponseSchema: z.ZodType<ListRolesResponse> = z.object({
  items: z.array(RoleSchema),
});

export const CreateRoleRequestSchema: z.ZodType<CreateRoleRequest> = z
  .object({
    companyId: z.uuid(),
    name: z.string().trim().min(1),
    permissionKeys: z.array(z.string().trim().min(1)),
  })
  .strict();

export const CreateRoleResponseSchema: z.ZodType<CreateRoleResponse> = z.object({
  role: RoleSchema,
  permissionKeys: z.array(z.string().trim().min(1)),
});

export const UpdateRoleRequestSchema: z.ZodType<UpdateRoleRequest> = z
  .object({
    companyId: z.uuid(),
    roleId: z.uuid(),
    name: z.string().trim().min(1),
    permissionKeys: z.array(z.string().trim().min(1)),
  })
  .strict();

export const RoleDetailSchema: z.ZodType<RoleDetailDto> = z.object({
  role: RoleSchema,
  permissionKeys: z.array(z.string().trim().min(1)),
  assignedMembershipCount: z.number().int().nonnegative(),
});

export const GetRoleResponseSchema: z.ZodType<GetRoleResponse> = RoleDetailSchema;
export const UpdateRoleResponseSchema: z.ZodType<UpdateRoleResponse> = RoleDetailSchema;

export const AssignRoleToMembershipRequestSchema: z.ZodType<AssignRoleToMembershipRequest> = z.object({
  companyId: z.uuid(),
  membershipId: z.uuid(),
  roleId: z.uuid(),
});

export const MembershipRoleSchema: z.ZodType<MembershipRoleDto> = z.object({
  roleId: z.uuid(),
  roleName: z.string().trim().min(1),
});

export const SetMembershipRolesRequestSchema: z.ZodType<SetMembershipRolesRequest> = z.object({
  companyId: z.uuid(),
  membershipId: z.uuid(),
  roleIds: z.array(z.uuid()),
});

export const SetMembershipRolesResponseSchema: z.ZodType<SetMembershipRolesResponse> = z.object({
  membershipId: z.uuid(),
  roles: z.array(MembershipRoleSchema),
});
